<template>
  <Transition appear>
    <div class="app-menu-mobile">
      <AppMenuMobileButton :open="true" @click="emit('close')" />
      <ul>
        <li class="nav-group pages">
          <div
            v-for="(app, key) in apps"
            :key="key"
            :class="['nav-item', key]"
            @click="emit('close')"
          >
            <a class="nav-link" :href="app.website" target="_blank">
              <span class="route-title">{{ app.name }}</span>
            </a>
          </div>
          <div
            v-for="page in sitePageItems"
            :key="page.uid"
            class="nav-item"
            @click="emit('close')"
          >
            <router-link
              class="nav-link"
              :to="{ name: page.route }"
              active-class="current"
            >
              <span class="route-title">{{ page.label }}</span>
            </router-link>
          </div>
        </li>
        <!--  -->
        <li class="nav-group social">
          <div
            v-for="(item, key) in social"
            :key="key"
            class="nav-item social"
          >
            <a class="nav-link" :href="item.url" target="_blank" :title="item.platform">
              <span class="route-icon">
                <FaIcon :icon="item.icon" />
              </span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { nanoid } from 'nanoid';
import { useAppStore } from '@/stores/app';
import AppMenuMobileButton from '@/components/AppMenuMobileButton.vue';
import FaIcon from '@/components/FaIcon.vue';

const emit = defineEmits<{
  close: [];
}>();

const store = useAppStore();

const navPages = computed(() => store.navPages);
const apps = computed(() => store.apps);
const social = computed(() => store.social);

const sitePageItems = computed(() =>
  navPages.value.map((item) => ({ uid: nanoid(5), ...item }))
);
</script>

<style lang="scss" scoped>
.app-menu-mobile-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

.app-menu-mobile {
  position: fixed;
  top: 20px;
  right: 20px;
  left: 20px;
  display: flex;
  background: white;
  border-radius: 20px;
  padding: 80px 40px 40px;
  color: gray;
  box-shadow: 0 50px 50px -40px rgba(0, 0, 0, 0.25),
    0 0 60px 0 rgba(0, 0, 0, 0.1);
  opacity: 1;
  transform: translateY(0);
  transition: 0.25s;

  &.v-enter-from,
  &.v-leave-active {
    opacity: 0;
    transform: translateY(100px);
  }
}

ul {
  padding: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.nav-group {
  display: flex;

  &.pages,
  &.apps {
    margin-bottom: 20px;
    flex-direction: column;

    .nav-link > span {
      font-weight: bold;
    }
  }

  &.social {
    justify-content: center;

    .nav-link {
      padding: 0 40px;
    }
  }
}

.nav-item {
  display: flex;

  a {
    width: 100%;
    padding: 20px 0;
    font-weight: 400;
    color: inherit;
    opacity: 1;
    transition: 0.25s;

    &:hover {
      opacity: 0.6;
    }

    &.current {
      opacity: 1;
    }
  }
}
</style>
